export default
{
    "title": '',
    "endP":"活动已结束",
    "versionLowPlaceholder":"此app版本过低，暂不支持跳转功能，请麻烦到app内查看",
    "versionPlaceholder":"此app版本过低，无法参与活动.请到 我的设置-版本 点击升级",
    "common":{
        "errorText":"不明なエラー",
        "errorMiss":"パラメータがありません",
        "submit": "Submit",
        "defaultInput": "please input",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "loginTimeout": "Havne't logged in or session timeout, please login again",
        "noData": "No Data",
        "custom": "Live Chat Support",
    },
    route: {
        dashboard: 'Dashboard',
        introduction: 'Introduction',
        documentation: 'Documentation',
        permission: 'Permission',
        icons: 'Icons',
        components: 'Components',
        componentIndex: 'Introduction',
        tinymce: 'Tinymce',
        markdown: 'Markdown',
        jsonEditor: 'JSON Editor',
        dndList: 'Dnd List',
        splitPane: 'SplitPane',
        avatarUpload: 'Avatar Upload',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'CountTo',
        componentMixin: 'Mixin',
        backToTop: 'BackToTop',
        charts: 'Charts',
        keyboardChart: 'Keyboard Chart',
        lineChart: 'Line Chart',
        mixChart: 'Mix Chart',
        example: 'Example',
        Table: 'Table',
        dynamicTable: 'Dynamic Table',
        dragTable: 'Drag Table',
        inlineEditTable: 'Inline Edit',
        complexTable: 'Complex Table',
        treeTable: 'Tree Table',
        customTreeTable: 'Custom TreeTable',
        tab: 'Tab',
        form: 'Form',
        createForm: 'Create Form',
        editForm: 'Edit Form',
        errorPages: 'Error Pages',
        page401: '401',
        page404: '404',
        errorLog: 'Error Log',
        excel: 'Excel',
        exportExcel: 'Export Excel',
        selectExcel: 'Export Selected',
        uploadExcel: 'Upload Excel',
        zip: 'Zip',
        exportZip: 'Export Zip',
        theme: 'Theme',
        clipboardDemo: 'Clipboard',
        i18n: 'I18n'
    },
    navbar: {
        logOut: 'Log Out',
        dashboard: 'Dashboard',
        github: 'Github',
        screenfull: 'screenfull',
        theme: 'theme'
    },
    login: {
        title: 'Login Form',
        logIn: 'Log in',
        username: 'Username',
        password: 'Password',
        any: 'any',
        thirdparty: 'Or connect with',
        thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
    },
    documentation: {
        documentation: 'Documentation',
        github: 'Github Repository'
    },
    permission: {
        roles: 'Your roles',
        switchRoles: 'Switch roles'
    },
    components: {
        documentation: 'Documentation',
        tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
        dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
        stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
        backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
        backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
        imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
    },
    table: {
        dynamicTips1: 'Fixed header, sorted by header order',
        dynamicTips2: 'Not fixed header, sorted by click order',
        dragTips1: 'The default order',
        dragTips2: 'The after dragging order',
        title: 'Title',
        importance: 'Imp',
        type: 'Type',
        remark: 'Remark',
        search: 'Search',
        add: 'Add',
        export: 'Export',
        reviewer: 'reviewer',
        id: 'ID',
        date: 'Date',
        author: 'Author',
        readings: 'Readings',
        status: 'Status',
        actions: 'Actions',
        edit: 'Edit',
        publish: 'Publish',
        draft: 'Draft',
        delete: 'Delete',
        cancel: 'Cancel',
        confirm: 'Confirm'
    },
    errorLog: {
        tips: 'Please click the bug icon in the upper right corner',
        description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
        documentation: 'Document introduction'
    },
    excel: {
        export: 'Export',
        selectedExport: 'Export selected items',
        placeholder: 'Please enter the file name(default excel-list)'
    },
    zip: {
        export: 'Export',
        placeholder: 'Please enter the file name(default file)'
    },
    theme: {
        change: 'Theme change',
        documentation: 'Theme documentation',
        tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
    },
    "veritrans": {
        "orderNo": "注文番号",
        "cardNum": "カード番号",
        "cardholderName": "カード名義人",
        "inputCard": "クレジットカード番号を入力して下さい",
        "inputCardholderName": "カード名義人を入力してください",
        "supportType": "サポートタイプ",
        "expiryDate": "有効期限",
        "csc": "セキュリティコード",
        "pay": "支払いを確認",
        "paySettle": "処理中",
        "payCancel": "支払いキャンセル",
        "payFailed": "支払い失敗",
        "succeed": "支払い完了",
        "fail": "支払いの問題、再支払い",
        "Cancelpay": "支払いをキャンセル",
        "repay": "再試行する",
        "contactUs": "カスタマーサービスへ"
    },
    "msgPush": {
        "tips": "Turn off {name} notifications?",
        "closePush": "If you turn off notifications, you may miss our exclusive deals!",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "appPush": "プッシュ通知",
        "emailPush": "メール通知",
        "loginFirst": "Not logged in or login disabled if you need to continue?"
    },
    errorCode: {
        '01282001': 'Account or password error',//登录用户名或密码错误
        '01282002': 'Account is deactivated',//登录用户已停用
        '01282003': 'Account is empty',//登录用户名为空
        '01282004': 'Password is empty',//登录密码为空
        '01282501': 'Partner is not exist',//代理商不存在
        '01282503': 'Partner status is invalid'//代理商已停用
    },
    //paygo---开始
    "route.home.flowType" : "従量課金（PAYG）モード",
    "route.home.flowTypeDesc": "有効なデータプラン/パッケージがない状態で従量課金（PAYG）モードを有効にすると、データ通信量に消費される可能性がある一部のアカウント残高が凍結されます。（レート：{rateCurrency} {rate}/MB）",
    "route.home.flowTypeDescLimit":"有効なデータプラン/パッケージがない状態で従量課金（PAYG）モードを有効にすると、データ通信量に消費される可能性がある一部のアカウント残高が凍結されます。 （レート：{rateCurrency} {rate}/MB 課金上限 {amountCurrency} {amount}）",
}



// WEBPACK FOOTER //
// ./src/lang/jp.js